const languageOptions = [
    { value: 'Abkhazian', label: 'Abkhazian' },
    { value: 'Afar', label: 'Afar' },
    { value: 'Afrikaans', label: 'Afrikaans' },
    { value: 'Akan', label: 'Akan' },
    { value: 'Albanian', label: 'Albanian' },
    { value: 'Amharic', label: 'Amharic' },
    { value: 'Arabic', label: 'Arabic' },
    { value: 'Aragonese', label: 'Aragonese' },
    { value: 'Armenian', label: 'Armenian' },
    { value: 'Assamese', label: 'Assamese' },
    { value: 'Avaric', label: 'Avaric' },
    { value: 'Avestan', label: 'Avestan' },
    { value: 'Aymara', label: 'Aymara' },
    { value: 'Azerbaijani', label: 'Azerbaijani' },
    { value: 'Bambara', label: 'Bambara' },
    { value: 'Bashkir', label: 'Bashkir' },
    { value: 'Basque', label: 'Basque' },
    { value: 'Belarusian', label: 'Belarusian' },
    { value: 'Bengali', label: 'Bengali' },
    { value: 'Bihari', label: 'Bihari' },
    { value: 'Bislama', label: 'Bislama' },
    { value: 'Bosnian', label: 'Bosnian' },
    { value: 'Breton', label: 'Breton' },
    { value: 'Bulgarian', label: 'Bulgarian' },
    { value: 'Burmese', label: 'Burmese' },
    { value: 'Catalan', label: 'Catalan' },
    { value: 'Chamorro', label: 'Chamorro' },
    { value: 'Chechen', label: 'Chechen' },
    { value: 'Chichewa', label: 'Chichewa' },
    { value: 'Chinese', label: 'Chinese' },
    { value: 'Chuvash', label: 'Chuvash' },
    { value: 'Cornish', label: 'Cornish' },
    { value: 'Corsican', label: 'Corsican' },
    { value: 'Cree', label: 'Cree' },
    { value: 'Croatian', label: 'Croatian' },
    { value: 'Czech', label: 'Czech' },
    { value: 'Danish', label: 'Danish' },
    { value: 'Divehi', label: 'Divehi' },
    { value: 'Dutch', label: 'Dutch' },
    { value: 'Dzongkha', label: 'Dzongkha' },
    { value: 'English', label: 'English' },
    { value: 'Esperanto', label: 'Esperanto' },
    { value: 'Estonian', label: 'Estonian' },
    { value: 'Ewe', label: 'Ewe' },
    { value: 'Faroese', label: 'Faroese' },
    { value: 'Fijian', label: 'Fijian' },
    { value: 'Finnish', label: 'Finnish' },
    { value: 'French', label: 'French' },
    { value: 'Frisian', label: 'Frisian' },
    { value: 'Fulah', label: 'Fulah' },
    { value: 'Galician', label: 'Galician' },
    { value: 'Ganda', label: 'Ganda' },
    { value: 'Georgian', label: 'Georgian' },
    { value: 'German', label: 'German' },
    { value: 'Greek', label: 'Greek' },
    { value: 'Guarani', label: 'Guarani' },
    { value: 'Gujarati', label: 'Gujarati' },
    { value: 'Haitian', label: 'Haitian' },
    { value: 'Hausa', label: 'Hausa' },
    { value: 'Hebrew', label: 'Hebrew' },
    { value: 'Herero', label: 'Herero' },
    { value: 'Hindi', label: 'Hindi' },
    { value: 'Hiri Motu', label: 'Hiri Motu' },
    { value: 'Hungarian', label: 'Hungarian' },
    { value: 'Icelandic', label: 'Icelandic' },
    { value: 'Ido', label: 'Ido' },
    { value: 'Igbo', label: 'Igbo' },
    { value: 'Indonesian', label: 'Indonesian' },
    { value: 'Interlingua', label: 'Interlingua' },
    { value: 'Interlingue', label: 'Interlingue' },
    { value: 'Inuktitut', label: 'Inuktitut' },
    { value: 'Inupiaq', label: 'Inupiaq' },
    { value: 'Irish', label: 'Irish' },
    { value: 'Italian', label: 'Italian' },
    { value: 'Japanese', label: 'Japanese' },
    { value: 'Javanese', label: 'Javanese' },
    { value: 'Kalaallisut', label: 'Kalaallisut' },
    { value: 'Kannada', label: 'Kannada' },
    { value: 'Kanuri', label: 'Kanuri' },
    { value: 'Kashmiri', label: 'Kashmiri' },
    { value: 'Kazakh', label: 'Kazakh' },
    { value: 'Khmer', label: 'Khmer' },
    { value: 'Kikuyu', label: 'Kikuyu' },
    { value: 'Kinyarwanda', label: 'Kinyarwanda' },
    { value: 'Kirghiz', label: 'Kirghiz' },
    { value: 'Kirundi', label: 'Kirundi' },
    { value: 'Komi', label: 'Komi' },
    { value: 'Kongo', label: 'Kongo' },
    { value: 'Korean', label: 'Korean' },
    { value: 'Kurdish', label: 'Kurdish'},
    { value: 'Lao', label: 'Lao' },
    { value: 'Latin', label: 'Latin' },
    { value: 'Latvian', label: 'Latvian' },
    { value: 'Limburgish', label: 'Limburgish' },
    { value: 'Lingala', label: 'Lingala' },
    { value: 'Lithuanian', label: 'Lithuanian' },
    { value: 'Luba-Katanga', label: 'Luba-Katanga' },
    { value: 'Luxembourgish', label: 'Luxembourgish' },
    { value: 'Macedonian', label: 'Macedonian' },
    { value: 'Malagasy', label: 'Malagasy' },
    { value: 'Malay', label: 'Malay' },
    { value: 'Malayalam', label: 'Malayalam' },
    { value: 'Maltese', label: 'Maltese' },
    { value: 'Manx', label: 'Manx' },
    { value: 'Maori', label: 'Maori' },
    { value: 'Marathi', label: 'Marathi' },
    { value: 'Marshallese', label: 'Marshallese' },
    { value: 'Mongolian', label: 'Mongolian' },
    { value: 'Nauru', label: 'Nauru' },
    { value: 'Navajo', label: 'Navajo' },
    { value: 'Ndebele', label: 'Ndebele' },
    { value: 'Ndonga', label: 'Ndonga' },
    { value: 'Nepali', label: 'Nepali' },
    { value: 'North Ndebele', label: 'North Ndebele' },
    { value: 'Northern Sami', label: 'Northern Sami' },
    { value: 'Norwegian', label: 'Norwegian' },
    { value: 'Norwegian Bokmål', label: 'Norwegian Bokmål' },
    { value: 'Norwegian Nynorsk', label: 'Norwegian Nynorsk' },
    // Starting with O
    { value: 'Occitan', label: 'Occitan' },
    { value: 'Ojibwe', label: 'Ojibwe' },
    { value: 'Oriya', label: 'Oriya' },
    { value: 'Oromo', label: 'Oromo' },
    // Starting with P
    { value: 'Pashto', label: 'Pashto' },
    { value: 'Persian', label: 'Persian' },
    { value: 'Polish', label: 'Polish' },
    { value: 'Portuguese', label: 'Portuguese' },
    { value: 'Punjabi', label: 'Punjabi' },
    { value: 'Quechua', label: 'Quechua' },
// Starting with R
{ value: 'Romanian', label: 'Romanian' },
{ value: 'Romansh', label: 'Romansh' },
{ value: 'Russian', label: 'Russian' },
{ value: 'Rwanda', label: 'Rwanda' },
// Starting with S
{ value: 'Samoan', label: 'Samoan' },
{ value: 'Sango', label: 'Sango' },
{ value: 'Sanskrit', label: 'Sanskrit' },
{ value: 'Sardinian', label: 'Sardinian' },
{ value: 'Scots', label: 'Scots' },
{ value: 'Scottish Gaelic', label: 'Scottish Gaelic' },
{ value: 'Serbian', label: 'Serbian' },
{ value: 'Shona', label: 'Shona' },
{ value: 'Sindhi', label: 'Sindhi' },
{ value: 'Sinhala', label: 'Sinhala' },
{ value: 'Slovak', label: 'Slovak' },
{ value: 'Slovenian', label: 'Slovenian' },
{ value: 'Somali', label: 'Somali' },
{ value: 'Southern Sotho', label: 'Southern Sotho' },
{ value: 'Spanish', label: 'Spanish' },
{ value: 'Sundanese', label: 'Sundanese' },
{ value: 'Swahili', label: 'Swahili' },
{ value: 'Swati', label: 'Swati' },
{ value: 'Swedish', label: 'Swedish' },
// Starting with T
{ value: 'Tajik', label: 'Tajik' },
{ value: 'Tamil', label: 'Tamil' },
{ value: 'Tatar', label: 'Tatar' },
{ value: 'Telugu', label: 'Telugu' },
{ value: 'Thai', label: 'Thai' },
{ value: 'Tibetan', label: 'Tibetan' },
{ value: 'Tigrinya', label: 'Tigrinya' },
{ value: 'Tonga', label: 'Tonga' },
{ value: 'Tswana', label: 'Tswana' },
{ value: 'Turkish', label: 'Turkish' },
{ value: 'Turkmen', label: 'Turkmen' },
{ value: 'Twi', label: 'Twi' },
// Starting with U
{ value: 'Uighur', label: 'Uighur' },
{ value: 'Ukrainian', label: 'Ukrainian' },
{ value: 'Urdu', label: 'Urdu' },
{ value: 'Uzbek', label: 'Uzbek' },
// Starting with V
{ value: 'Venda', label: 'Venda' },
{ value: 'Vietnamese', label: 'Vietnamese' },
{ value: 'Volapük', label: 'Volapük' },
{ value: 'Walloon', label: 'Walloon' },
{ value: 'Welsh', label: 'Welsh' },
{ value: 'Wolof', label: 'Wolof' },
// Starting with X
{ value: 'Xhosa', label: 'Xhosa' },
// Starting with Y
{ value: 'Yiddish', label: 'Yiddish' },
{ value: 'Yoruba', label: 'Yoruba' },
// Starting with Z
{ value: 'Zhuang', label: 'Zhuang' },
{ value: 'Zulu', label: 'Zulu' },
]
export default languageOptions;